import { Route } from 'react-router-dom';
import { SittersList } from './list';

export const SittersRoute = (
  <Route path="sitters">
    <Route index element={<SittersList />} />
  </Route>
);
